import Image from 'next/image'
import React from 'react'
import styled from 'styled-components'
import { sanitizeImage, imgix } from '@lojinha/helpers'

type Props = {
  itemImageUrl: string
}

const ImageWrapper = styled.div`
  height: 394px;
  width: 100%;
  position: relative;
  display: flex;
  overflow: hidden;
  align-items: center;
  border-radius: 8px;

  & img {
    object-fit: cover;
    vertical-align: middle;
  }

  ${({ theme }) => theme.media.below('lg')} {
    height: 238px;
  }
`

const PureImage = styled.img`
  position: absolute;
  width: auto;
  object-fit: cover;
`

export const ItemImage = ({ itemImageUrl }: Props) => {
  const imageUrl = `${imgix.DOMAIN}${sanitizeImage({
    imageUrl: itemImageUrl,
    size: 'big',
    desktopImage: true,
  })}`

  const lqipUrl = imgix.withParams(imageUrl, {
    px: 16,
    blur: 200,
    fm: 'webp',
  })

  const optimizedUrl = imgix.withParams(imageUrl, {
    fm: 'webp',
  })

  return (
    <ImageWrapper>
      <PureImage src={lqipUrl} alt="" aria-hidden loading="lazy" />
      <Image
        src={optimizedUrl.replace(imgix.DOMAIN, '/')}
        alt=""
        aria-hidden
        layout="fill"
      />
    </ImageWrapper>
  )
}
